import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import { swal, typeChecker } from "../../../utils/methods";
import { _post } from "../../../utils/network";

import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb.component';
import FormField from "../../../components/Form/FormField/FormField.component";
import LoadingButton from '../../../components/LoadingButton/LoadingButton.component';

const SETTING_KEY = 'FIRST_POPUP';

const FirstPopupEdit = () => {
	const { t } = useTranslation();
	const [saveButtonIsLoading, setSaveButtonIsLoading] = useState(false);
	const [pageIsLoading, setPageIsLoading] = useState(true);
	const [setting, setSetting] = useState({});
	const breadcrumbItems = [
		{ title: t('dashboard'), link: '/dashboard' },
		{ title: t('first_popup') }
	];
	const confirmSwal = statements => {
		swal(() => statements(), {
			text: t('are_you_sure_to_do_this'),
			confirmButtonText: t('yes'),
			cancelButtonText: t('no')
		});
	};

	const getSetting = async () => {
		setPageIsLoading(true);
		let response = await _post('/settings/admin/getOne', { setting_key: SETTING_KEY });
		setPageIsLoading(false);
		switch(response.code){
			case 200:
				setSetting(response.data.setting?.setting_content || {});
				break;
			default:
				toast.error(response[t('api_message')]);
		}
	};
	const updateSetting = async (event) => {
		event.preventDefault();
		if(saveButtonIsLoading)
			return 0;
		let title = event.target.firstPopupTitle.value.trim();
		if(!typeChecker(title, 'title'))
			return toast.warn(t('title') + ' ' + t('must_have_at_least_3_characters'));
		let description = event.target.firstPopupDescription.value.trim();
		if(!typeChecker(description, 'title'))
			return toast.warn(t('description') + ' ' + t('must_have_at_least_3_characters'));
		let image = document.querySelector('#firstPopupImage-upload-list img')?.getAttribute('src')?.trim() || '';
		if(!typeChecker(image, 'image'))
			return toast.warn(t('image') + ' ' + t('cant_be_empty'));
		let link = event.target.firstPopupLink.value.trim();
		if(!typeChecker(link, 'link'))
			return toast.warn(t('link_is_not_valid'));
		let buttonText = event.target.firstPopupButtonText.value.trim();
		if(!typeChecker(buttonText, 'title'))
			return toast.warn(t('button_text') + ' ' + t('must_have_at_least_3_characters'));
		let isActive = event.target.firstPopupIsActive.checked;
		let body = {
			setting_key: SETTING_KEY,
			setting_content: {
				title,
				description,
				is_active: isActive,
				link,
				button_text: buttonText,
				image
			},
			setting_more: {}
		};
		confirmSwal(async () => {
			setSaveButtonIsLoading(true);
			let response = await _post('/settings/admin/edit', body);
			setSaveButtonIsLoading(false);
			switch(response.code){
				case 200:
					toast.success(response[t('api_message')]);
					setSetting(body.setting_content);
					break;
				default:
					toast.error(response[t('api_message')]);
			}
		});
	};

	useEffect(() => {
		getSetting();
	}, []);

	return (
		<>
			<Breadcrumb items={breadcrumbItems} />
			<div className="card mb-3">
				<div className="card-header">
					<h5 className="mb-0">{t('first_popup')}</h5>
				</div>
				<div className="card-body bg-light">
					{pageIsLoading ?
						<div className="text-center py-4">
							<div className="spinner-border text-primary" role="status">
								<span className="visually-hidden">Loading...</span>
							</div>
						</div>
					:
						<form onSubmit={updateSetting}>
							<div className="row gx-2">
								<FormField fieldKey="firstPopupTitle" title={t('title')} value={setting?.title} required />
								<FormField type="toggle" fieldKey="firstPopupIsActive" title={t('active')} value={setting?.is_active} required />
								<FormField type="text" fieldKey="firstPopupDescription" title={t('description')} value={setting?.description} required />
								<FormField type="image" fieldKey="firstPopupImage" title={t('image')} value={setting?.image} required tip="x*x" fileMaxSize={2} />
								<FormField fieldKey="firstPopupButtonText" title={t('button_text')} value={setting?.button_text} required />
								<FormField fieldKey="firstPopupLink" title={t('link')} value={setting?.link} required ltr />
							</div>
							<div>
								<LoadingButton className="btn btn-primary d-inline-block mt-3 me-2" type="submit" name="save" isLoading={saveButtonIsLoading}>
									<i className="fa fa-save"></i> {t('update')}
								</LoadingButton>
							</div>
						</form>
					}
				</div>
			</div>
		</>
	);
};

export default FirstPopupEdit;
